import Swal from "sweetalert2";

async function fetchTransactionData(id, model = 'Purchase') {
    const response = await fetch(
        `/ajax/collection/${id}?model=${model}`
    );
    const { data } = await response.json();

    return data;
}

async function fetchDeliveryOrderCode() {
    const response = await fetch('/ajax/generate-code?model=DeliveryOrder');
    const { data } = await response.json();

    return data;
}

async function fetchCollections({ model, relations = '', query = '', limit = 0, offset = 0 }) {
    try {
        const response = await fetch(`/ajax/collections?model=${model}&relations=${relations}${query ? '&' + query : ''}&limit=${limit}&offset=${offset}`);
        const { data } = await response.json();
        

        if (!response.ok) {
            Swal.fire({
                title: "Error!",
                text: response.message,
                icon: "error",
            });
        }

        return data;
    } catch (error) {
        Swal.fire({
            title: "Error!",
            text: error.message,
            icon: "error",
        });
    }
}

async function fetchCollection({ id, model, relations = '' }) {
    try {
        const response = await fetch(`/ajax/collection/${id}?model=${model}&relations=${relations}`);
        const { data } = await response.json();

        if (!response.ok) {
            Swal.fire({
                title: "Error!",
                text: response.message,
                icon: "error",
            });
        }

        return data;
    } catch (error) {
        Swal.fire({
            title: "Error!",
            text: error.message,
            icon: "error",
        });
    }
}

async function fetchApi({ endpoint, method = 'POST', headers, body = null, params = null }) {
    const request = {
        method,
        headers,
        body,
    };

    if (params) {
        endpoint += '?' + new URLSearchParams(params).toString();
    }

    if (body && headers['Content-Type'] === 'application/json') {
        request.body = JSON.stringify(body);
    }

    try {
        const response = await fetch(endpoint, request);
        const result = await response.json();
    
        return result;
    } catch (error) {
        throw new Error(error.message || `Failed to post ${endpoint}.`);
    }
}

window.fetchCollection = fetchCollection;
window.fetchCollections = fetchCollections;
window.fetchTransactionData = fetchTransactionData;
window.fetchDeliveryOrderCode = fetchDeliveryOrderCode;
window.fetchApi = fetchApi;